define(function (require) {
    "use strict";


    var LE = require("app"),
        lpUtils = require("utils/lpUtils"),
        Template = require("connection-templates/chatTab/chatBubbles/cobrowseInvitation.tmpl"),
        CoBrowseOfferView = {},

        OFFER_TIMEOUT = 120000;

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        CoBrowseOfferView = Marionette.ItemView.extend({
            template: Template,
            className: 'cobrowse-container',
            ui: {
                acceptButton: "button .cobrowse-invitation-accept",
                cancelButton: "button .cobrowse-invitation-reject",
                invitationContainer: ".bubble-line-type-cobrowse"
            },
            events: {
                "click .cobrowse-invitation-accept": "_onAccepted",
                "click .cobrowse-invitation-reject": "_onCancelled"
            },

            initialize: function (options) {
                options = options || {};
                this.serviceID = options.serviceID;
                this._chatVent = options.chatVent;

                this.enabled = true;
                this._addExpiresTimeout();
                this._chatVent.trigger("chatConnection:cobrowse:offered", this.serviceID);
            },

            _onAccepted: function () {
                if (this.enabled) {
                    this._chatVent.trigger("chatConnection:cobrowse:accepted", this.serviceID);
                    this._disableOffer();
                }
            },

            _onCancelled: function () {
                if (this.enabled) {
                    this._chatVent.trigger("chatConnection:cobrowse:rejected", this.serviceID);
                    this._disableOffer();
                }
            },

            _disableOffer: function () {
                this.enabled = false;
                this.ui.invitationContainer.addClass("disabled");
            },

            _addExpiresTimeout: function () {
                setTimeout(_.bind(function () {
                    if (this.enabled) {
                        this._disableOffer();
                    }
                }, this), OFFER_TIMEOUT);
            }
        });
    });
    return CoBrowseOfferView;

});
